import React from 'react';
import BackBar from './BackBar';
import '../pages/PrivacyPolicy.css';
import './InfoPage.css';

export default function InfoPage({ title, intro, updated = false, updatedDate = "2026-09-08", updatedLabel = "September 8, 2026", children, contents = [] }) {
  return <div className="legal-page info-page">
    <BackBar />
    <main className={`legal-container${contents.length ? " info-with-contents" : ""}`}>
      <header className="legal-header">
        <div className="brand-mark">KACHNG</div>
        <h1 className="legal-title">{title}</h1>
        {intro && <p className="info-intro">{intro}</p>}
        {updated && <p className="legal-intro">Last Updated: <time dateTime={updatedDate}>{updatedLabel}</time></p>}
      </header>
      <div className="info-layout">
      {contents.length > 0 && <nav className="info-contents" aria-label="On this page">
        <h2>On this page</h2>
        <ol>{contents.map(([id, label]) => <li key={id}><a href={`#${id}`}>{label}</a></li>)}</ol>
      </nav>}
      <div className="legal-content">{children}</div>
      </div>
    </main>
  </div>;
}
